import { Tag, Link } from 'carbon-components-react';
import React from 'react';
export default {
  Tag,
  Link,
  React
};